import styles from "./Trivia.module.css";
import { useCallback, useEffect, useState } from "react";
import Choice from "../components/Choice";
import supabase from "../supabaseClient";

const Trivia = ({
  question,
  choices,
  question_id,
  info,
  onCorrect,
  wrongTitle
}) => {

  const [percentages, setPercentages] = useState();

  useEffect(() => {
    getCount();
  }, []);

  const [selectedAnswer, setSelectedAnswer] = useState();

  const createResponse = async (choice) => {
    const { error } = await supabase
      .from('responses')
      .insert({ question_id: question_id, choice: choice })
  }

  const handleReset = () => {
    onCorrect(false);
    setSelectedAnswer(undefined);
  };

  const roundingPercentages = (data) => {
    // Largest Remainder Method to ensure integers sum to 100
    const entries = Object.entries(data);
    const floors = entries.map(([key, value]) => [key, Math.floor(value || 0)]);
    const sumFloors = floors.reduce((sum, [, val]) => sum + val, 0);
    let diff = 100 - sumFloors;

    const result = floors.reduce((acc, [key, val]) => {
      acc[key] = val;
      return acc;
    }, {});

    const byFractionDesc = entries
      .map(([key, value]) => ({ key, frac: (value || 0) - Math.floor(value || 0) }))
      .sort((a, b) => b.frac - a.frac);

    for (let i = 0; i < byFractionDesc.length && diff > 0; i += 1) {
      result[byFractionDesc[i].key] += 1;
      diff -= 1;
    }

    return result;
  };

  const getCount = async () => {
    const { data, error } = await supabase.rpc('count_response', { question: question_id });
    if (error) return;

    const total = data.reduce((sum, e) => sum + e.count, 0);

    if (total === 0) {
      // No responses yet; avoid NaN and leave percentages undefined
      setPercentages(undefined);
      return;
    }

    const h = {};
    data.forEach((a) => {
      h[a.choice] = (a.count / total) * 100.0;
    });

    const rounded = roundingPercentages(h);
    setPercentages(rounded);
  };


  const onChoiceClick = (choice) => {
    umami?.track('Click a choice on trivia ' + question_id);
    createResponse(choice)
    setSelectedAnswer(choice)
    if (choices[choice].correct) { onCorrect(true) }
  }

  const message = () => {
    if (selectedAnswer == undefined) return question

    if (choices[selectedAnswer].correct) {
      return "Correct."
    } else {
      return wrongTitle
    }
  }

  return (
    <div className={styles.triviaParent}>
      { (selectedAnswer !== undefined) && (
        <button 
          className={styles.resetButton} 
          onClick={handleReset}
          title="Reset question"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 4V10H7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3.51 15A9 9 0 1 0 6 5L1 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      )}
      
      <div className={styles.question}>
          <p className={styles.correctIncorrect}> { message() } </p>
          
        { selectedAnswer !== undefined && <p className={styles.infoMessage}> { info } </p> }
      </div>
      {
        choices.map((choice, i) => {
          return (
            <Choice key={i} choice={choice} percent={(percentages || {})[String(i)]} onClick={() => { onChoiceClick(i) } } clicked={selectedAnswer !== undefined} />
          );
        })
      }
    </div>
  );
};

export default Trivia;
